/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPromoCode_user = {
    readonly activePromotion: {
        readonly code: string | null;
    } | null;
    readonly tradeFirm?: {
        readonly rewards: {
            readonly currentPromoSegment: {
                readonly segmentCode: string | null;
            } | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"TradePromo_user">;
    readonly " $refType": "PdpSharedPromoCode_user";
};
export type PdpSharedPromoCode_user$data = PdpSharedPromoCode_user;
export type PdpSharedPromoCode_user$key = {
    readonly " $data"?: PdpSharedPromoCode_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPromoCode_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "activePromotion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userId",
                      "variableName": "userId"
                    }
                  ],
                  "concreteType": "currentPromoSegmentType",
                  "kind": "LinkedField",
                  "name": "currentPromoSegment",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "segmentCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TradePromo_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '0c4e3b6815dc158e2e2b682ebf36a2ed';
export default node;
